/**
 * 模型配置表状态管理（vuex的state可以单独出来，便于管理，同样mutations和actions都可以提取出来）
 *
 * @author PeterLee
 * @since 2026-05-21
 */
const state = {
   //表单校验规则
   rules: {
      //提供商名称
      providerName:[{
         required: true,
         message: '请输入提供商名称',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 20,
           message: '长度在 1 到 20 个字符',
           trigger: 'blur'
         }
       ],
      //协议类型
      protocolType:[{
         required: true,
         message: '请选择协议类型',
         trigger: 'change'
       }],
      //接口基础地址
      baseUrl:[{
         required: true,
         message: '请输入接口基础地址',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 255,
           message: '长度在 1 到 255 个字符',
           trigger: 'blur'
         }
       ],
      //接口密钥
      apiKey:[{
         required: true,
         message: '请输入接口密钥',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 250,
           message: '长度在 1 到 250 个字符',
           trigger: 'blur'
         }
       ],
      //模型名称
      modelName:[{
         required: true,
         message: '请输入模型名称',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 50,
           message: '长度在 1 到 50 个字符',
           trigger: 'blur'
         }
       ],
      //是否默认
      isDefault:[{
         required: true,
         message: '请选择是否默认',
         trigger: 'change'
       }],
      //描述
      description:[{
         required: false,
         message: '请输入描述',
         trigger: 'blur'
      },
        {
         min: 1,
         max: 20,
         message: '长度在 1 到 20 个字符',
         trigger: 'blur'
       }
      ],
      //状态
      state:[{
         required: true,
         message: '请选择状态',
         trigger: 'change'
       }],
   },
   //列信息
   columnInfo: {
       //提供商名称
       providerName:{
            visible:true,
            label:"提供商名称"
       },
       //协议类型
       protocolType:{
            visible:true,
            label:"协议类型"
       },
       //接口基础地址
       baseUrl:{
            visible:true,
            label:"接口基础地址"
       },
       //接口密钥
       apiKey:{
            visible:true,
            label:"接口密钥"
       },
       //模型名称
       modelName:{
            visible:true,
            label:"模型名称"
       },
       //是否默认
       isDefault:{
            visible:true,
            label:"是否默认"
       },
       //状态
       state:{
            visible:true,
            label:"状态"
       },
       //描述
       description:{
            visible:true,
            label:"描述"
       },
   },
   //表格数据（查询结果）
   tableData: [],
   //共有数据条数（分页控件）
   totalCount: 0,
   //选项列表（列表下拉框选择）
   options: {
   },
   //查询参数
   queryParams: {
      //当前页数（分页控件）
      currPage: 1,
      //每页条数（分页控件）
      limit: 10,
      //是否升序
      ascOrder: false,
      //排序字段
      orderField: "",
      //此处为可能需要修改部分，请不要忽略
      param: {
         //提供商名称
         providerName: undefined,
         //协议类型
         protocolType: undefined,
         //接口基础地址
         baseUrl: undefined,
         //接口密钥
         apiKey: undefined,
         //模型名称
         modelName: undefined,
         //是否默认 0否 1是
         isDefault: undefined,
        //状态
        state: undefined,
        //描述
        description: undefined,
      }
   },
   //时间范围
   dateRange: {
   },
   //表单组件信息
   formInfo: {
      //表单组件弹出框显示控制
      dialogVisible: false,
      //是否增加操作（非增加操作会隐藏部分操作）
      isAdd: false,
      //编辑回显数据
      editData: {},
   },
   //更多按钮信息
   moreButtonProps:[
      //{command:'test',label:'示例按钮',permissionCode:'itil:event'}
   ]
}
export default state